/**
 * Returns a trimmed to midnight date object of the current date or of the given optional date
 * @param date optional date to copy
 */
export const newDate = (date?: Date): Date => {
    let dateWithoutTime;
    if (date) {
        dateWithoutTime = new Date(date);
    } else {
        dateWithoutTime = new Date();
    }
    return trimToMidnight(dateWithoutTime);
};

/**
 * Returns the given date object with time components set to zero.
 * @param date
 */
export const trimToMidnight = (date: Date): Date => {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
